module.exports = __webpack_public_path__ + "img/wave_form.b871d499.svg";